(ns hai.admin-ui.data-tasks.helpers
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]))

(def ->label :task/title)

;; The shared Tasks glyph (:task_alt), matching the navbar, route, and home card.
(def icon icons/outlined-task_alt)

(defn ->icon
  [_task]
  icon)

(defn ->tint
  [_]
  t/--tasks)
